import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ViewPageLabelsContentFragment_content: GraphQLTaggedNode = graphql`
	fragment ViewPageLabelsContentFragment_content on Content {
		id
		type
		status
		operations {
			operation
			targetType
		}
		space {
			id
		}
		labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
			count
			nodes {
				__typename
				id
				label
				name
				prefix
			}
		}
	}
`;
